import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { Button, ButtonType } from '../../components';
import { useDependencies } from '../../dependencies';

export const StripeInProgress = observer((): JSX.Element => {
  const { stores, services: { tracker } } = useDependencies();
  const { t } = useTranslation();
  const { verification } = stores;

  const getDescription2 = (): string => {
    if (verification.stripeRequiresInput()) {
      return t('identityCheck.stripeVerification.inProgressRequiresInput.description2');
    }

    return t('identityCheck.stripeVerification.inProgressRequiresNoInput.description2');
  }

  // Mirrors Angular verification-service.js:255 — tracks document upload start.
  const stripeUpload = (): void => {
    tracker.track('verification-modal', { action: 'stripe-document-upload-started' });
    verification.openStripe('upload');
  }

  // Mirrors Angular verification-service.js:187 — tracks resume of an
  // already-started Stripe verification flow.
  const stripeContinue = (): void => {
    tracker.track('verification-modal', { action: 'stripe-verification-continued' });
    verification.openStripe('continue');
  }

  return (
    <div className='flex justify-center mb-4 border-2 p-2 rounded-2xl md:w-[250px] md:h-[260px]'>
      <div className='mt-3'>
        <div className='mb-2'>{getDescription2()}</div>

        <div className='text-center'>
          {verification.stripeRequiresInput()
            ? (
              <Button
                buttonType={ButtonType.primary}
                disabled={stores.verification.loadingStripe}
                onClick={stripeUpload}>
                {t('identityCheck.stripeVerification.upload')}
              </Button>
            ) : (
              <Button
                buttonType={ButtonType.primary}
                disabled={stores.verification.loadingStripe}
                onClick={stripeContinue}>
                {t('identityCheck.stripeVerification.continue')}
              </Button>
            )}
          <div className='text-sm mt-6'>{t('identityCheck.allowPopups')}</div>
        </div>
      </div>
    </div>
  );
});
